import { render, staticRenderFns } from "./AddressManage.vue?vue&type=template&id=af392438"
import script from "./AddressManage.vue?vue&type=script&lang=js"
export * from "./AddressManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports